import React, { useEffect, useState } from 'react'
import { Autocomplete, Chip, TextField } from '@mui/material'
import { debounce } from 'lodash'
import axios from 'axios'


export default function UserSelect({ users, setUsers, sx }) {
  const [uids, setUids] = useState(Array.isArray(users) ? users.map(user => user.id) : [])
  const [userList, setUserList] = useState([])
  const [selectedUsers, setSelectedUsers] = useState(Array.isArray(users) ? users : [])
  const [userSearch, setUserSearch] = useState('');

  useEffect(() => {
    setSelectedUsers(Array.isArray(users) ? users : []);
  }, [users]);

  const onInput = (e) => {
    const searchString = e.target.value
    if (searchString) {
      axios({
        method: "post",
        url: "/api/user/search",
        data: {
          fid: 2,
          attributes: ["id", "firstName", "lastName", "username", "email"],
          status: "Active",
          exUids: uids,
          searchString,
          limit: 5
        }
      }).then(res => {
        const ul = [...res.data].map(user => {
          return { label: `${user.firstName} ${user.lastName} (${user.email})`, user: user }
        })
        setUserList(ul)
      })
    } else {
      setUserList([])
    }
  }

  const handleInput = debounce(onInput, 700)

  const handleSelect = (e, value) => {
    if (value) {
      const user = value.user
      const tmp = [...selectedUsers]
      tmp.push({ id: user.id, firstName: user.firstName, lastName: user.lastName })
      setSelectedUsers(tmp)
      const tmp2 = [...users]
      tmp2.push(user)
      setUsers(tmp2)
      setUids(tmp.map(u => u.id))
    }
    setUserSearch('')
  }

  const handleDelete = (uid) => {
    setSelectedUsers(curr => curr.filter(user => user.id !== uid))
    setUsers(selectedUsers.filter(user => user.id !== uid))
    setUids(selectedUsers.filter(user => user.id !== uid).map(u => u.id))
  }

  return (
    <>
      <Autocomplete
        disablePortal
        options={userList}
        sx={sx}
        renderInput={(params) => {
          return <TextField {...params} value={userSearch} onChange={(e) => setUserSearch(e.target.value)} label="Users" />
        }}
        clearOnEscape
        
        onInput={handleInput}
        onChange={handleSelect}
      />
      <div className="username-display-area">
        {Array.isArray(selectedUsers) && selectedUsers.map((user) => {
          return (
            <Chip key={user.id}
              label={`${user.firstName} ${user.lastName}`}
              onDelete={() => handleDelete(user.id)}
              sx={{ marginRight: '10px' }}
            />
          )
        })}
      </div>
    </>
  )
}
